import { render, staticRenderFns } from "./DirectoryMain.vue?vue&type=template&id=9879886e&scoped=true"
import script from "./DirectoryMain.vue?vue&type=script&lang=js"
export * from "./DirectoryMain.vue?vue&type=script&lang=js"
import style0 from "./DirectoryMain.vue?vue&type=style&index=0&id=9879886e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9879886e",
  null
  
)

export default component.exports